export const commons = {
  languages: {
    A1: 'A1 - iniziale',
    A2: 'A2 - sotto la media',
    B1: 'B1 è medio',
    B2: 'B2 - Sopra la media',
    C1: 'C1 - Avanzato',
    C2: 'C2 è professionale',
    Native: 'Madrelingua'
  },
  roles: {
    club: 'Club',
    artist: 'Artista',
    admin: 'Amministratore'
  },
  artistJobs: {
    Hostess: 'Hostess',
    GoGo: 'Gogo',
    Strip: 'Striscia'
  },
  schedule: {
    Monday: 'Lunedi',
    Tuesday: 'Martedì',
    Wednesday: 'Mercoledì',
    Thursday: 'Giovedì',
    Friday: 'Venerdì',
    Saturday: 'Sabato',
    Sunday: 'Domenica'
  },
  paymentFrequency: {
    Daily: 'Giorno',
    Weekly: 'Settimana',
    Monthly: 'Mese'
  },
  flightPaymentType: {
    Club: 'A spese del club',
    Artist: "A spese dell'artista",
    Credit: 'Prestito',
    Agreement: 'Di accordo',
    Compensation: 'Compensazione'
  },
  artistConsumation: {
    label: 'Consumazione',
    Active: 'Attivo',
    Passive: 'Passivo'
  },
  workItemType: {
    Request: 'Applicazioni',
    Invite: 'Invito'
  },
  workItemStatus: {
    Pending: 'In attesa',
    Accepted: 'Accettato',
    Rejected: 'Respinto',
    Withdrawn: 'Svelare',
    Expired: 'Facilmente',
    ContractOngoing: 'Il contratto è valido',
    ContractRequestedEndDate: 'Ha richiesto la data del contratto',
    FinishingContract: 'Il contratto termina',
    ContractCompleted: 'Il contratto è completato',
    ClubSetEndDate: 'Il club ha fissato la data di fine',
    Cancelled: 'Annullato'
  },
  artistStatuses: {
    LookingForWork: 'Nella ricerca',
    OnContract: 'Sul contratto',
    FinishingContract: 'Finisco il contratto',
    OnVacation: 'In congedo',
    HiddenFromSearch: 'Nascosto dalla ricerca'
  },
  loading: {
    generic: 'I dati vengono caricati ...',
    requests: 'Le applicazioni vengono caricate ...',
    invites: 'Gli inviti sono caricati ...'
  },
  flightCompensationOptions: {
    oneMonth: 'Per 1 mese di contratto',
    twoMonths: 'Per 2 mesi di contratto',
    threeMonths: 'Per 3 mesi di contratto',
    sixMonths:
      'Per 6 mesi di contratto, il club acquista un biglietto di ritorno',
    backTicket: 'Biglietto di ritorno'
  },
  transportFromAirport: {
    label: "Trasporto dall'aeroporto/stazione",
    options: {
      clubOrganizes: 'Organizza il club',
      artistSelf: "L'artista si prende"
    }
  },
  notFound: {
    generic: 'La registrazione è vuota.',
    requests: 'Non ci sono ancora applicazioni.',
    invites: "Non c'è ancora alcun invito.",
    artists: "Attualmente, l'elenco degli artisti è vuoto",
    search:
      'Non abbiamo trovato il club su tua richiesta: (Segnala, per favore, a riguardo al supporto in modo da poter migliorare la ricerca'
  },
  artistParametres: {
    weight: 'Peso',
    height: 'Altezza',
    body: 'Corpo',
    chest: 'Brencent del torace',
    waist: 'La circonferenza della vita',
    hips: 'I fianchi dei fianchi'
  },
  dressCodeOptions: {
    strip: 'Strisce',
    underwear: 'Lingerie',
    longDress: 'Vestito lungo',
    body: 'Corpo',
    shortDress: 'Vestito corto'
  },
  time: {
    years:
      '{count, plural, one {# anno} few {# anni} many {# anni} other {# anni}}',
    months:
      '{count, plural, one {# mese} few {# mesi} many {# mesi} other {# mesi}}',
    days: '{count, plural, one {# giorno} few {# Giorno} many {# giorni} other {# Giorno}}'
  },
  contact_support: 'Hai bisogno di aiuto? Contatta il supporto',
  success_send_data: 'I dati vengono inviati correttamente',
  show_full: 'Mostra completamente',
  worked_for: 'Lavorato (a)',
  club_reviews: 'Recensioni sul club',
  club_response: 'Risposta del club',
  response: 'Risposta',
  send: 'Inviare',
  cm: 'cm',
  kg: 'kg',
  no_rating_yet: "Non c'è ancora alcuna valutazione",
  rating_allow:
    'Gli artisti possono valutare il club solo dopo 21 giorni di lavoro',
  rating: 'valutazione',
  rating_popup_header_1: 'Il tuo contratto nel club',
  rating_popup_header_2: 'Completato',
  contractWeeks:
    '{count, plural, one {# settimana} few {# settimane} many {# settimane} other {# settimane}}',
  rating_popup_text:
    'È importante per noi e altri artisti conoscere la tua opinione su questo luogo. Si prega di valutare il lavoro in questo club.',
  error_rating: 'Errore di valutazione',
  no_rating:
    'Non esiste un elemento per valutare questo club o è già stato valutato',
  housing_quality: 'Qualità abitativa',
  dressing_quality: 'La qualità dello spogliatoio',
  management: 'Guida e personale',
  anonymous: 'Lascia la recensione in modo anonimo',
  rate_work: 'Valutazione, lavoro in questo club',
  submit: 'Inviare',
  years: 'anni',
  allow_note: 'Consenti le notifiche',
  allow_note_1:
    'Consentitemi le notifiche per il corretto funzionamento della piattaforma in modo da non perdere eventi importanti:',
  allow_note_2: 'Applicazioni e inviti',
  allow_note_3: 'Risposte dai club',
  allow_note_4: 'Messaggi di artisti o manager',
  allow_note_5: 'Inviamo solo notifiche di lavoro - nessun spam.',
  'follow-us-in-social': 'Seguici nei social network:',
  continue: 'Continuare',
  'continue-with-google': 'Continua con Google',
  artistHiringIsOpen: 'Un set di artisti è aperto',
  artistHiringIsClosed: 'Il set di artisti è chiuso',
  acceptWithExperience: 'Accettiamo senza esperienza',
  dontAcceptWithoutExperience: 'Non accettiamo senza esperienza',
  info: 'Informazioni',
  copyLink: 'Copia il link',
  withExperience: 'Con esperienza',
  withouthExperience: 'Senza esperienza',
  agree: "Sono d'accordo con le condizioni",
  change: 'Modifica',
  add: 'Aggiungere',
  citizenship: 'Cittadinanza',
  selectCountry: 'Scegli il paese',
  save: 'Salva',
  'save-and-continue': 'Salva e continua',
  edit: 'Modificare',
  portfolio: 'Portfolio',
  close: 'Vicino',
  closed: 'Chiuso',
  finish: 'Completare',
  help: 'Aiuto',
  logout: 'Esci',
  country: 'Paese',
  place: 'Posizione',
  deleteAccount: 'Elimina un account',
  changePassword: 'Cambiare la password',
  hide: 'Nascondere',
  delete: 'Eliminare',
  exit: 'Sì, voglio uscire',
  'undo-to-account': "Torna all'account",
  location: 'Posizione',
  language: 'Lingue',
  reviews: 'Recensioni',
  parametres: 'Parametri',
  about: 'Su di te',
  my: 'Mio',
  photo: 'Foto',
  video: 'Video',
  experience: 'Esperienza',
  galery: 'Galleria',
  write: 'Scrivere',
  yes: 'SÌ',
  step: 'Fare un passo',
  no: 'NO',
  or: 'O',
  resend: 'Inviare',
  open: 'aprire',
  cancel: 'Cancellare',
  need: 'Bisogno',
  dontNeed: 'Non necessario',
  endWork: 'Fine del lavoro',
  startDate: 'La data di inizio del lavoro',
  endDate: 'La fine della fine del lavoro',
  vacancy: 'Vacante',
  creditation: 'Prestito dei biglietti',
  aroundTheClock: 'Tutto il giorno',
  flightTickets: 'Voli',
  ticketCreditation: 'Prestito dei biglietti',
  crazyMenu: 'Menu pazzo',
  tea: 'Tè',
  show: 'Spettacolo',
  deposit: 'Depositare',
  guarantee: 'Garanzia',
  rate: 'Offerta',
  clubFee: 'Commissione del club',
  separated: 'Separato',
  forShift: 'Per i turni',
  required: 'Necessariamente',
  optional: 'Non necessariamente',
  quantity: 'Quantità',
  withouthExprience: 'Senza esperienza',
  choreographerInClub: 'La presenza di un coreografo nel club',
  photoshootParticipation: 'Partecipazione ai servizi fotografici',
  artistsInShift: 'Artisti nel turno',
  scenes: 'Scene',
  dynamicPole: 'Pilone Dynamics',
  staticPole: 'Statica di Pilone',
  artistTraining: 'Formazione di artisti',
  teching: 'Istruzione',
  dressCodeForArtists: 'Codice di abbigliamento per artisti',
  dressCode: 'Codice di abbigliamento',
  rentPayment: 'Pagamento di alloggi',
  utilitiesPayment: 'Pagamento della comunale',
  clubProvidedAccommodation: "L'alloggio dell'artista negli alloggi dal club",
  housingPhoto: 'Foto di alloggi',
  noteEditLater: 'Puoi apportare modifiche in seguito',
  paydByArtist: 'Artista',
  paydByClub: 'Club',
  peopleInRoom: 'Uomo nella stanza a',
  uploadFromDevice: 'Scarica dal dispositivo',
  uploadManyFromDevice: 'Carica diverse foto dal dispositivo',
  selectMainPhoto: 'Scegli la foto principale',
  photoParams: 'La dimensione della foto non deve superare {size} MB',
  videoParams:
    'La dimensione del video non deve superare {size} MB, formati supportati: MP4, QuickTime,',
  general: 'Generale',
  payments: 'Pagamenti',
  full: 'Pieno',
  topless: 'Toples',
  gogo: 'Go-moh',
  crazymenu: 'Menu pazzo',
  continueFilling: 'Continua a riempire',
  exitShort: 'Esci',
  search: 'Ricerca',
  other: 'Altro',
  foreignLanguages: 'Lingue straniere',
  dancer: 'Ballerino',
  untilNow: 'Ad oggi',
  invite: 'Invitare',
  cancelInvite: "Annulla l'invito",
  dateFormatPlaceholder: 'Dd.mm.yy',
  askArtist: "Fai una domanda all'artista",
  askClub: 'Fai una domanda al club',
  reject: 'Rifiutare',
  accept: 'Accettare',
  confirm: 'Confermare',
  iConfirm: 'Confermare',
  workAt: 'Funziona con',
  setLastDate: "Imposta l'ultima data",
  lastWorkDay: "L'ultimo giorno di lavoro",
  cancelArrangement: "Annulla l'accordo",
  back: 'Indietro',
  wantedVacancy: 'Posti vacanti desiderati',
  addClub: 'Aggiungi il club',
  goToInvitation: "Vai all'invito",
  goToRequest: 'Vai alla richiesta',
  vacancyConsider: 'Quali posti vacanti stai prendendo in considerazione?',
  super: 'Super',
  clubLocation: 'La posizione del club',
  specify: 'Indicare',
  housing: 'Alloggio',
  position: 'Posizione',
  guest: 'Ospite',
  workingHours: 'Orari di apertura',
  isPaydByClub: 'Pagato dal club',
  isntPaydByClub: 'Non pagato dal club',
  utilityPayments: 'Pagamento delle utility',
  payment: 'Pagamento',
  request: 'Richiesta',
  penalties: 'Multe',
  aboutClub: 'Sul club',
  sendRequest: 'Fare domanda a',
  cancelRequest: "Annulla l'applicazione",
  profile: 'Profilo',
  chat: 'Chiacchierata',
  housigInClubApartsRequired:
    'È richiesta una sistemazione negli alloggi dal club'
};
